import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLevelsService } from '../../../../services/levels/api/api-levels.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-level-edit-modal',
  templateUrl: './level-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LevelEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  levelId: number = 0;
  level: number = 0;
  nextLevelExperienceRequired: number = 0;
  nextLevelReward: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiLevelsService: ApiLevelsService, private alertsService: AlertsService) {}

  show(levelId: number, level: number, nextLevelExperienceRequired: number, nextLevelReward: number, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.levelId = levelId;
    this.level = level;
    this.nextLevelExperienceRequired = nextLevelExperienceRequired;
    this.nextLevelReward = nextLevelReward;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLevelsService.editLevel(this.levelId, this.level, this.nextLevelExperienceRequired, this.nextLevelReward).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Level updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating level : ' + error);
      }
    );
  }
}
